import { useMutation, useQueryClient } from "react-query";
import deleteAttributesHandler from "./handlers/deleteAttributesHandler";
import deleteAttributesResponder from "./responders/deleteAttributesResponder";
import removeAttributesFromStore from "../../../helpers/Attribute/removeAttributesFromStore";

const useDeleteAttributes = () => {
  const queryClient = useQueryClient();
  const deleteMutation = useMutation(
    deleteAttributesHandler,
    deleteAttributesResponder({ queryClient })
  );

  /**
   * Edit Attribute
   *
   * @param {Props} deletedItems: Array of IDs of attributes to remove
   * @param {boolean} newRequest optional defaults to true, if false is sent an api request will not be attempted
   */
  const deleteAttributes = async (props, newRequest = true) => {
    if (!props.args.deletedItemsIds) {
      return console.error(
        "deleteAttributes | props.args.deletedItemsIds is required"
      );
    }

    if (newRequest === false) {
      return removeAttributesFromStore({
        queryClient,
        removedItems: props.args.deletedItemsIds,
      });
    }

    const response = await deleteMutation.mutateAsync(props);
    return response;
  };

  const {
    isLoading: isLoadingAttributes,
    isError: hasDeleteAttributesError,
    error: deleteAttributesError,
    isSuccess: deleteAttributesSuccess,
  } = deleteMutation;

  return {
    deleteAttributes,
    isLoadingAttributes,
    hasDeleteAttributesError,
    deleteAttributesError,
    deleteAttributesSuccess,
  };
};

export default useDeleteAttributes;
